<template>
  <div id="base_header">
    <div class="header_title">
      <router-link to="/"><img src="@/assets/toplink_logo_white.png" alt="toplink_logo"></router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'baseHeader',
}
</script>
<style>
  #base_header{
    position: sticky;
    top: 0;
    z-index: 20;
  }
  .header_title{
    width: 100%;
    height: 85px;
    background-color: #313131;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .header_title img { 
    max-width: 100%;
    height: 58px;  
    margin: 5px 0;
  }
</style>